import { ConnectionStatus, Network } from '@capacitor/network'
import { createGlobalState } from '@vueuse/core'
import { ref } from 'vue'

export const useNetworkStatus = createGlobalState(() => {
  const connected = ref<ConnectionStatus['connected']>(true)
  const connectionType = ref<ConnectionStatus['connectionType']>('unknown')
  const initialCheck = ref(false)

  Network.addListener('networkStatusChange', status => {
    initialCheck.value = true
    connected.value = status.connected
    connectionType.value = status.connectionType
  })

  Network.getStatus().then(status => {
    connected.value = status.connected
    connectionType.value = status.connectionType
    initialCheck.value = true
  })

  return {
    connected,
    connectionType,
    initialCheck,
  }
})
